import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ElementService {

    treeviewOpen = false;
    constructor() {

    }
    
    public openCloseTreeview(event: any) {
        const element =  event.target.closest('.nav-item');
        this.treeviewOpen = element.className.includes("open");
        if(!this.treeviewOpen) {
           element.className = "nav-item menu-is-opening menu-open";
            return
        }
       element.className = "nav-item";
    }

}